import React, { memo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './formInput.scss'

const FormInputComponent = ({
  label, type, name, onChange, required, disabled, value, errors, ignoreErrors, className, unit, ...rest
}) => {
  const formGroupClass = classNames(className, 'form-group')

  return (
    <div className={formGroupClass}>
      {label && (
        <label className="form-label" htmlFor={name}>
          {`${label} ${required ? '*' : ''}`}
        </label>
      )}
      <div className="input">
        <input
          {...rest}
          className={(errors && errors.length > 0) ? 'invalid' : ''}
          value={value}
          type={type}
          name={name}
          onChange={onChange}
          required={required}
          disabled={disabled}
        />
        {unit && <span className="unit">{unit}</span>}
      </div>
      {!ignoreErrors
        ? (
          <div className="text-small text-error errors">
            {errors && errors.map((e, idx) => <span key={idx} className="error">{e}</span>)}
          </div>
        )
        : ''}
    </div>
  )
}

FormInputComponent.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  ignoreErrors: PropTypes.bool,
  className: PropTypes.string,
  unit: PropTypes.string,
}

FormInputComponent.defaultProps = {
  type: 'text',
  label: '',
  required: false,
  errors: [],
  ignoreErrors: false,
  className: '',
  unit: '',
}

export default memo(FormInputComponent)
